import { composeAppNavigation, type Route } from '#features/navigation/composeAppNavigation'
import { allRoutes } from './routes/routes'

const components = composeAppNavigation(allRoutes)
export type AppRoute = Route<typeof allRoutes>
export const { AppNavigationContext, useAppNavigation } = components
